import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import ReactPlayer from 'react-player'
import { LargeBusiness } from '../../Constants';

class VideoModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
        modal: false
      };
}

  handleToggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    localStorage.setItem('videoActive', false);
    this.props.toggleVideoPopup(!this.state.modal)
  };

  componentDidMount() {
    this.setState({
        modal: this.props.videoPopup
    })
}

//  /.galleries/eir/icon-none-svg/modal-close.png


render() {
    const imgPath = LargeBusiness.isLBSite ?
     "/large-business/export/sites/default" :
    "";

    return (
    <Modal className="videoModalDialog" centered={true} isOpen={this.state.modal || this.props.videoPopup } toggle={this.handleToggle} >
          <img onClick={this.handleToggle} src={imgPath+"/.galleries/eir/icon-none-svg/modal-close.png"} alt="Close" className="videoModal-close-icon" />
          <ModalBody className="videoModalBody">
            <ReactPlayer url={this.props.videoUrl} controls={true} playing={this.state.modal || this.props.videoPopup} width='100%'
              height='100%'  />
          </ModalBody>
    </Modal>    
    );
  }
}

export default VideoModal;